import React, { useState } from 'react'
import { close_icon } from '../../assets/images'
import { Table } from '../common/molecules'
import { raiseDisputeModalSchema } from '../../schemas/table'
import { dsButtonPrimary, joinButtonClasses } from '../../utils/buttonStyles'

const RaiseDisputeModal = ({ visible = false, service = '', bill_amount = 0, close = () => {}, submitHandler = () => {}}) => {
  const [comment, setComment] = useState('')
  const [error, setError] = useState('')

  const handler = () => {
    const value = (comment || '').trim()
    if(!value) setError('Please enter the reason to submit!')
    else submitHandler(value)
  }

  const changeHandler = (event) => {
    setComment(event.target.value)
    setError('')
  }

  return (
    <div
    className={`fixed z-10 inset-0 overflow-y-auto ${visible ? '' : 'hidden'}`}
    aria-labelledby='modal-title'
    role='dialog'
    aria-modal='true'
    >
      <div className='flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0'>
        <div
          className='fixed inset-0 bg-gray-900 bg-opacity-40 transition-opacity'
          aria-hidden='true'
          onClick={close}
        ></div>

        <span className='hidden sm:inline-block sm:align-middle sm:h-screen' aria-hidden='true'>
          &#8203;
        </span>

        <div 
            className='inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden transform duration-75 sm:my-8 sm:align-middle sm:p-6'
            style={{width: 800, height: 420}}
        >
          <div className='flex flex-row-reverse'>
              <img src={close_icon} alt='closeIcon' className='cursor-pointer' onClick={close} />
          </div>
          <h1 className='text-xl mb-0 font-extrabold text-gray-700'>Reason for rejecting invoice</h1>
          <Table 
            headers={['SERVICE', 'BILL AMOUNT', 'INVOICE STATUS']}
            data={[{service, bill_amount}]}
            tableschema={raiseDisputeModalSchema}
            classes='mt-8 rounded-lg'
            changeHandler={changeHandler}
            value={comment}
            error={error}
          />
          <button 
            onClick={handler}
            className={joinButtonClasses(dsButtonPrimary, 'm-auto mt-12 h-11 px-5')}
          >
            Add comment
          </button>
        </div>
      </div>
    </div>

  )
}

export default RaiseDisputeModal
